import React from 'react';
import { formatYMD } from '../utils';

const CustomRangeInput = React.forwardRef(({ start, end, onClick, placeholderStart, placeholderEnd, className }, ref) => {
  // ZMIANA: nie używamy toISOString
  const formatDate = (d) => d ? formatYMD(d) : '';
  return (
    <div className={`range-inputs ${className || ''}`} ref={ref} onClick={onClick}>
      <input type="text" readOnly value={formatDate(start)} placeholder={placeholderStart} aria-label={placeholderStart}/>
      <span className="range-sep">→</span>
      <input type="text" readOnly value={formatDate(end)} placeholder={placeholderEnd} aria-label={placeholderEnd}/>
    </div>
  );
});

export default CustomRangeInput;
